import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useDevelopmentData } from '../context/DevelopmentDataContext';

interface DevelopmentDataGuardProps {
  redirectTo?: string;
  allowDashboard?: boolean;
  currentPath?: string;
}

const DevelopmentDataGuard: React.FC<DevelopmentDataGuardProps> = ({ 
  redirectTo = '/development/overview',
  allowDashboard = false,
  currentPath = ''
}) => {
  const { hasData, isLoading } = useDevelopmentData();

  // If still loading, show a loading indicator
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        padding: '2rem'
      }}>
        <div style={{ marginBottom: '1rem' }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#3949ab" strokeWidth="4" strokeDasharray="30 30" strokeDashoffset="0">
              <animateTransform 
                attributeName="transform" 
                type="rotate" 
                from="0 12 12" 
                to="360 12 12" 
                dur="1s" 
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
        <div style={{ fontSize: '16px', color: '#333' }}>
          Checking development data...
        </div>
      </div>
    );
  }

  // If no data exists and this is not the dashboard (or it's the dashboard but we don't allow it)
  // then redirect to the dashboard with a message
  if (!hasData && (!allowDashboard || (allowDashboard && currentPath !== '/development/overview'))) {
    return <Navigate to={redirectTo} replace />;
  }

  // Otherwise, render the child routes
  return <Outlet />;
};

export default DevelopmentDataGuard;
